<template>
  <v-app>
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title>Baixando arquivo...</v-card-title>
        <v-card-text>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container style="background-color: #f8f9fb; margin: 0px; padding: 0px">
      <v-col cols="12">
        <consulta-dinamica-filtros
          :loading="isLoading"
          @consultar="consultar"
          @erro="mostrarMensagem"
        />
      </v-col>
    </v-container>

    <v-dialog v-model="showMessage" persistent max-width="320">
      <v-card>
        <v-card-title>Mensagem</v-card-title>
        <v-card-text class="d-flex justify-center text-center">
          {{ msg }}
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="primary" @click="showMessage = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container
      style="background-color: #eee"
      id="consulta-dinamica"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12" sm="6" lg="4">
          <base-material-stats-card
            color="rgb(71 130 180)"
            icon="mdi-file-document-outline"
            title="Total de contratos"
            :value="summary.totalRegistros"
            :valuex="false"
            :sub-text="''"
            :sub-text2="
              consultou
                ? 'Registros retornados pela consulta'
                : 'Aguardando consulta'
            "
          />
        </v-col>
      </v-row>

      <br />

      <v-divider></v-divider>

      <br /><br />

      <base-material-card
        icon="mdi-magnify"
        title="Consulta dinamica"
        style="margin-top: 0px !important"
        color="rgb(71 130 180)"
        class="px-5 py-0"
      >
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="items"
              :items-per-page="itemsPerPage"
              hide-default-footer
              class="elevation-0 no-hover-effect"
            >
              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td
                    class="linha"
                    style="
                      width: 5%;
                      font-size: 11px !important;
                      font-weight: bold;
                      font-family: Verdana, Geneva, Tahoma, sans-serif;
                    "
                  >
                    {{ row.item.contrato }}
                  </td>
                  <td class="linha">{{ row.item.titular || "-" }}</td>
                  <td class="linha">{{ row.item.empresa || "-" }}</td>
                  <td class="linha">{{ row.item.tipoContrato || "-" }}</td>
                  <td class="linha">{{ row.item.statusContrato || "-" }}</td>
                  <td class="linha">{{ formatDate(row.item.dataContrato) }}</td>
                  <td class="linha">{{ row.item.produto || "-" }}</td>
                  <td class="linha">
                    {{ formatCurrency(row.item.ticketMedio) }}
                  </td>
                  <td class="linha">{{ row.item.telefone || "-" }}</td>
                </tr>
              </template>

              <template v-slot:no-data>
                <div class="py-10 text-center text--secondary">
                  {{
                    consultou
                      ? "Nenhum registro encontrado para os filtros aplicados."
                      : "Preencha os filtros e clique em Consultar."
                  }}
                </div>
              </template>

              <template v-slot:footer>
                <v-spacer></v-spacer>
                <v-row class="d-flex justify-center mt-4">
                  <v-col cols="12" sm="6">
                    <v-pagination
                      v-model="currentPage"
                      :length="totalPages"
                      :total-visible="5"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <br />

        <div v-if="consultou" class="d-flex justify-end">
          <div style="width: 120px">
            <span
              @click="downloadExcel"
              style="
                color: green;
                font-size: 48px;
                margin-right: 12px;
                cursor: pointer;
              "
              title="Baixar Excel"
            >
              <i class="fas fa-file-excel"></i>
            </span>
          </div>
        </div>

        <br />
      </base-material-card>
    </v-container>
  </v-app>
</template>

<script>
import ConsultaDinamicaFiltros from "./components/ConsultaDinamicaFiltros.vue";
import ConsultaDinamicaService from "../../services/consultaDinamica";

export default {
  name: "ConsultaDinamica",

  components: {
    ConsultaDinamicaFiltros,
  },

  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      totalElements: 0,
      totalPagesFromApi: 0,
      showMessage: false,
      showProgress: false,
      msg: "",
      isLoading: false,
      consultou: false,
      lastPayload: null,
      headers: [
        { text: "Contrato", value: "contrato", sortable: false },
        { text: "Titular", value: "titular", sortable: false },
        { text: "Empresa", value: "empresa", sortable: false },
        { text: "Tipo", value: "tipoContrato", sortable: false },
        { text: "Status", value: "statusContrato", sortable: false },
        { text: "Data do Contrato", value: "dataContrato", sortable: false },
        { text: "Produto", value: "produto", sortable: false },
        { text: "Ticket Medio", value: "ticketMedio", sortable: false },
        { text: "Telefone", value: "telefone", sortable: false },
      ],
      items: [],
      summary: {
        totalRegistros: 0,
        totalAtivos: 0,
        ticketMedioGeral: 0,
        ticketMedioGeralFormatado: "R$ 0,00",
        filtrosAplicados: [],
      },
    };
  },

  computed: {
    totalPages() {
      return this.totalPagesFromApi || 1;
    },
  },

  watch: {
    async currentPage(newPage) {
      if (!this.lastPayload || !this.consultou) return;

      this.isLoading = true;

      try {
        const response = await ConsultaDinamicaService.consultar(
          this.lastPayload,
          newPage,
          this.itemsPerPage,
        );

        if (response.status === 200) {
          const data = response.data;
          this.items = Array.isArray(data.content) ? data.content : [];
        }
      } catch (error) {
        this.mostrarMensagem("Nao foi possivel carregar a pagina solicitada.");
      } finally {
        this.isLoading = false;
      }
    },
  },

  methods: {
    async consultar({ payload, appliedFilters }) {
      this.isLoading = true;
      this.currentPage = 1;
      this.summary.filtrosAplicados = appliedFilters || [];
      this.lastPayload = payload;

      try {
        const response = await ConsultaDinamicaService.consultar(
          payload,
          1,
          this.itemsPerPage,
        );

        if (response.status === 200) {
          this.consultou = true;
          const data = response.data;

          this.items = Array.isArray(data.content) ? data.content : [];
          this.totalElements = data.totalElements || 0;
          this.totalPagesFromApi = data.totalPages || 1;

          this.updateSummary();

          if (!this.items.length) {
            this.mostrarMensagem(
              "Nenhum registro foi encontrado para os filtros informados.",
            );
          }
        }
      } catch (error) {
        this.mostrarMensagem(
          "Nao foi possivel executar a consulta no momento.",
        );
      } finally {
        this.isLoading = false;
      }
    },

    async downloadExcel() {
      if (!this.lastPayload) {
        this.mostrarMensagem("Execute uma consulta antes de baixar o Excel.");
        return;
      }

      this.showProgress = true;

      try {
        const response = await ConsultaDinamicaService.consultarXls(
          this.lastPayload,
        );

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `consulta-dinamica-${new Date().getTime()}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.mostrarMensagem(
          "Nao foi possivel realizar o download do Excel no momento.",
        );
      } finally {
        this.showProgress = false;
      }
    },

    updateSummary() {
      const totalRegistros = this.totalElements;
      const totalAtivos = this.items.filter(
        (item) => item.statusContrato === "Ativo",
      ).length;
      const itemsCount = this.items.length;
      const ticketMedioGeral = itemsCount
        ? this.items.reduce(
            (acc, item) => acc + Number(item.ticketMedio || 0),
            0,
          ) / itemsCount
        : 0;

      this.summary = {
        ...this.summary,
        totalRegistros,
        totalAtivos,
        ticketMedioGeral,
        ticketMedioGeralFormatado: this.formatCurrency(ticketMedioGeral),
      };
    },

    mostrarMensagem(mensagem) {
      this.msg = mensagem;
      this.showMessage = true;
    },

    formatDate(data) {
      if (!data) {
        return "-";
      }

      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },

    formatCurrency(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

.justify-center {
  justify-content: center;
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}

.chips-wrapper {
  display: flex;
  flex-wrap: wrap;
}
</style>
